import { TimelineMax, TweenMax } from 'gsap/TweenMax';
import selectors from '@/scripts/animation/animation-selectors';

function getAssets(section) {
  return {
    elements: Array.from(section.querySelectorAll(selectors.fadeIn)),
  };
}

export default {
  trigger: selectors.fadeIn,
  set() {
    const { elements } = getAssets(this.section);
    return TweenMax.set(elements, { autoAlpha: 0 });
  },

  animate() {
    const { elements } = getAssets(this.section);
    const tl = new TimelineMax();
    return tl
      .staggerTo(
        elements, selectors.duration,
        { autoAlpha: 1, clearProps: 'all' },
        selectors.delay.stagger, selectors.delay.stage_4,
      );
  },
};



// WEBPACK FOOTER //
// ./scripts/animation/elements/fade-in.js